import { jsxs as i, jsx as r } from "react/jsx-runtime";
import { forwardRef as m } from "react";
import { Link as p } from "../link/link.js";
import { AnimatedArrow as y } from "../animated-arrow.js";
import n from "./cta-banner.module.css.js";
import c from "clsx";
const C = m(
  function({
    className: e,
    children: t,
    size: a = "lg",
    tracking: o = !0,
    variant: s = "blue",
    ...f
  }, x) {
    return /* @__PURE__ */ i(
      p,
      {
        className: c(
          e,
          n.ctaBanner,
          n[a],
          n[s]
        ),
        icon: !1,
        ref: x,
        tracking: o && Object.assign({ eventCategory: `cta-banner_${s}` }, o),
        ...f,
        children: [
          t,
          /* @__PURE__ */ r(y, { className: n.arrowSmall }),
          /* @__PURE__ */ i("svg", { viewBox: "0 0 60 32", className: n.arrowLarge, children: [
            /* @__PURE__ */ r("line", { x1: "16", y1: "16", x2: "65", y2: "16" }),
            /* @__PURE__ */ r("line", { x1: "0", y1: "0", x2: "16", y2: "16" }),
            /* @__PURE__ */ r("line", { x1: "0", y1: "32", x2: "16", y2: "16" })
          ] })
        ]
      }
    );
  }
), j = Object.assign(C, {
  Content: m(
    function({ className: e, ...t }, a) {
      return /* @__PURE__ */ r("div", { className: c(e, n.content), ref: a, ...t });
    }
  )
});
export {
  j as CtaBanner
};
//# sourceMappingURL=cta-banner.js.map
